import React from "react";
import { v4 as uuidv4 } from "uuid";

interface Page {
  key: string;
  title: string;
}
interface PageDocumentAddPageProps {
  pages: Page[];
  activePage: number;
  onTabClick: (index: number) => void;
  onAddTab?: () => void;
}

export const DocumentPagesTabs = ({ pages, activePage, onTabClick, onAddTab }: PageDocumentAddPageProps) => {
  return (
    <div className="flex flex-col justify-center p-4 border border-slate-200 dark:border-slate-700 border-b-0">
      <div className="relative">
        <div className="absolute bottom-0 w-full h-px bg-slate-200 dark:bg-slate-700" aria-hidden="true"></div>
        <ul className="relative text-sm font-medium flex flex-nowrap -mx-4 sm:-mx-6 lg:-mx-8 overflow-x-scroll no-scrollbar">
          {pages.map((tab, index) => (
            <DocEditorTab
              key={tab.key}
              title={tab.title}
              active={index == activePage}
              onClick={() => onTabClick(index)}
            />
          ))}
          {onAddTab && (
            <DocEditorTab
              key="add"
              title="+ Dodaj"
              onClick={() => onAddTab()}
              disabled={pages.some((x) => x.key == "0")}
            />
          )}
        </ul>
      </div>
    </div>
  );
};

interface DocEditorTabProps {
  active?: boolean;
  onClick?: () => void;
  title: string;
  disabled?: boolean;
}

const docEditorTabColors: Record<string, string> = {
  true: "text-primary-500 border-primary-500 border-b-2",
  false: "text-slate-500 dark:text-slate-400 hover:text-slate-600 dark:hover:text-slate-300",
};

const DocEditorTab = ({ active, title, onClick, disabled }: DocEditorTabProps) => {
  const disabledClass = disabled ? "opacity-50 cursor-not-allowed" : "";
  return (
    <li
      className="mr-6 last:mr-0 first:pl-4 sm:first:pl-6 lg:first:pl-8 last:pr-4 sm:last:pr-6 lg:last:pr-8 cursor-pointer"
      onClick={() => {
        if (!disabled && onClick) onClick();
      }}
    >
      <span className={`block pb-3 whitespace-nowrap ${docEditorTabColors[active + ""]} ${disabledClass}`}>
        {title}
      </span>
    </li>
  );
};
